// AboutDropdown.jsx
import React, { useEffect, useState } from "react";
import "../styles/AboutDropdown.css";
import { NavLink } from "react-router-dom";
import { SOCIAL } from "../config/site";

function useIsMobile(breakpoint = 1024) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);

  return isMobile;
}

export default function AboutDropdown() {
  const isMobile = useIsMobile(1024);
  const [open, setOpen] = useState(false);

  const toggleDropdown = (e) => {
    if (!isMobile) return;
    e.preventDefault();
    setOpen((prev) => !prev);
  };

  const closeDropdown = () => {
    if (isMobile) setOpen(false);
  };

  useEffect(() => {
    setOpen(false);
  }, [isMobile]);

  return (
    <div className={`mega-wrapper ${open && isMobile ? "is-open" : ""}`}>
      <button
        className="dropdown-toggle"
        onClick={toggleDropdown}
        aria-expanded={isMobile ? open : undefined}
        type="button"
      >
        About Us
      </button>

      <div className="mega-menu">
        <div className="mega-menu-inner">
          {/* LEFT */}
          <div className="mega-left">
            <h3>The Heart of Cloudare</h3>
            <p>
              Learn more about Cloudare, our growth journey, partnerships,
              achievements and global presence.
            </p>
            <NavLink to="/about" className="mega-link" onClick={closeDropdown}>
              Learn about Cloudare →
            </NavLink>
          </div>

          {/* CENTER */}
          <div className="mega-center">
            <div className="mega-column">
              <NavLink to="/success-stories" onClick={closeDropdown}>
                Success Stories
              </NavLink>
              <NavLink to="/events-and-webinars" onClick={closeDropdown}>
                Webinars
              </NavLink>
              <NavLink to="/awards-and-achievements" onClick={closeDropdown}>
                Awards and Achievements
              </NavLink>
            </div>

            <div className="mega-column">
              {/* External URLs MUST use <a>, not NavLink */}
              <a
                href={SOCIAL.blog}
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeDropdown}
              >
                Blogs
              </a>
              <a
                href={SOCIAL.careers}
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeDropdown}
              >
                Careers
              </a>
              <NavLink to="/locations" onClick={closeDropdown}>
                Locations
              </NavLink>
              <NavLink to="/contact-us" onClick={closeDropdown}>
                Contact Us
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
